import React, { useEffect } from 'react';
import RegionForm from '../../../enrollment/region/RegionForm';
import RegionList from '../../../enrollment/region/RegionList';
import useRegions from '../../../enrollment/region/useRegions';

function RegionManagement() {
  const { regions, loading, error, fetchRegions, addRegion } = useRegions();

  useEffect(() => {
    fetchRegions();
  }, [fetchRegions]);

  return (
    <div style={{ maxWidth: 700, margin: '2em auto', padding: 24 }}>
      <h1>Region Management</h1>
      <RegionForm onSuccess={fetchRegions} />
      <div style={{ marginTop: 32 }}>
        <RegionList regions={regions} loading={loading} error={error} />
      </div>
    </div>
  );
}

export default RegionManagement;
